/* Aurora bundle campaign: the countdown shared by both sections, and the picker.

   Pricing is not done here. The picker puts one line in the cart per bottle and Shopify's
   automatic discounts price the basket, exactly as the discovery set works. If the discount
   window is closed the cart simply charges the normal price, so the two can never disagree
   about money — only about what the page says, which is why the clock is driven by a real
   end date and never loops. */
(function () {
  'use strict';

  function readJSON(root, sel) {
    var el = root.querySelector(sel);
    if (!el) { return null; }
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* One deadline, plus an extension someone sets by hand. Past the deadline with no
     extension the clock is removed rather than sitting at zero. It never restarts. */
  function startClock(root, copy) {
    var clock = root.querySelector('[data-clock]');
    if (!clock) { return; }

    var endsAt = Date.parse(root.dataset.ends || '');
    if (isNaN(endsAt)) { clock.hidden = true; return; }
    var extAt = Date.parse(root.dataset.extended || '');

    var label = root.querySelector('[data-clock-label]');
    var d = root.querySelector('[data-d]');
    var h = root.querySelector('[data-h]');
    var m = root.querySelector('[data-m]');
    var s = root.querySelector('[data-s]');
    if (!d || !h || !m || !s) { return; }

    function tick() {
      var now = Date.now();
      var extended = !isNaN(extAt) && now >= endsAt && extAt > now;
      var target = extended ? extAt : endsAt;

      if (now >= endsAt && !extended) { clock.hidden = true; return; }
      clock.hidden = false;

      if (label) { label.textContent = extended ? (copy.clock_extended || '') : (copy.clock_label || ''); }

      var left = Math.max(0, Math.floor((target - now) / 1000));
      var dd = Math.floor(left / 86400); left -= dd * 86400;
      var hh = Math.floor(left / 3600); left -= hh * 3600;
      var mm = Math.floor(left / 60);
      d.textContent = pad(dd);
      h.textContent = pad(hh);
      m.textContent = pad(mm);
      s.textContent = pad(left - mm * 60);
    }

    tick();
    setInterval(tick, 1000);
  }

  function startPicker(root) {
    var copy = readJSON(root, '[data-aurfb-copy]') || {};
    var items = (readJSON(root, '[data-aurfb-items]') || []).filter(function (it) { return it && it.id; });

    startClock(root, copy);
    if (!items.length) { root.hidden = true; return; }

    var HI = parseInt(root.dataset.hi, 10) || 4;
    var LO = parseInt(root.dataset.lo, 10) || 3;
    if (HI > items.length) { HI = items.length; }
    if (LO >= HI) { LO = HI - 1; }
    if (LO < 1) { LO = 1; }

    var grid = root.querySelector('[data-grid]');
    var hintEl = root.querySelector('[data-hint]');
    var namesEl = root.querySelector('[data-names]');
    var wasEl = root.querySelector('[data-was]');
    var nowEl = root.querySelector('[data-now]');
    var cta = root.querySelector('[data-cta]');
    var say = root.querySelector('[data-say]');
    var plans = [].slice.call(root.querySelectorAll('.aurfb__plan'));

    /* Everything buyable starts chosen, up to the larger tier, so the page opens on the
       better basket rather than asking the shopper to build one from nothing. */
    var picked = [];
    items.forEach(function (it) { if (it.ok && picked.length < HI) { picked.push(it.id); } });

    var cards = items.map(function (it) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'aurfb__card';
      if (!it.ok) { b.disabled = true; }

      var shot = document.createElement('span');
      shot.className = 'aurfb__shot';
      if (it.img) {
        var im = document.createElement('img');
        im.src = it.img;
        im.alt = it.name;
        im.loading = 'lazy';
        shot.appendChild(im);
      }

      /* The chosen state is carried by a hairline edge, which is quiet by design, so the
         card also gets a stroked tick. No plate behind it: it fades in over the bottle. */
      var tick = document.createElement('span');
      tick.className = 'aurfb__tick';
      tick.setAttribute('aria-hidden', 'true');
      tick.innerHTML = '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" ' +
        'stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M3 8.6 L6.4 12 L13 4.8"/></svg>';
      shot.appendChild(tick);

      b.appendChild(shot);

      var body = document.createElement('span');
      body.className = 'aurfb__body';

      var nm = document.createElement('span');
      nm.className = 'aurfb__nm';
      nm.textContent = it.name;
      body.appendChild(nm);

      if (it.fam) {
        var fm = document.createElement('span');
        fm.className = 'aurfb__fam';
        fm.textContent = it.fam;
        body.appendChild(fm);
      }
      if (it.scent) {
        var sc = document.createElement('span');
        sc.className = 'aurfb__sc';
        sc.textContent = it.scent;
        body.appendChild(sc);
      }
      b.appendChild(body);

      b.addEventListener('click', function () { toggle(it); });
      grid.appendChild(b);
      return { el: b, it: it };
    });

    function toggle(it) {
      if (!it.ok) { return; }
      var i = picked.indexOf(it.id);
      if (i === -1) {
        /* Not chosen: adding it takes the basket back up to the larger tier. */
        if (picked.length < HI) { picked.push(it.id); }
      } else if (picked.length > LO) {
        /* At the larger tier: dropping one moves down to the smaller tier. */
        picked.splice(i, 1);
      } else {
        /* At the smaller tier it never goes lower. Swap this one for whichever is left
           out, so the tap still does what the shopper meant and the basket stays valid. */
        var out = null;
        for (var k = 0; k < items.length; k++) {
          if (items[k].ok && picked.indexOf(items[k].id) === -1) { out = items[k].id; break; }
        }
        if (out) { picked.splice(i, 1, out); }
      }
      render();
    }

    plans.forEach(function (p) {
      p.addEventListener('click', function () {
        var want = parseInt(p.dataset.size, 10);
        if (want === HI) {
          for (var k = 0; k < items.length && picked.length < HI; k++) {
            if (items[k].ok && picked.indexOf(items[k].id) === -1) { picked.push(items[k].id); }
          }
        } else {
          while (picked.length > want) { picked.pop(); }
        }
        render();
      });
    });

    function nameOf(id) {
      for (var k = 0; k < items.length; k++) { if (items[k].id === id) { return items[k].name; } }
      return '';
    }

    function render() {
      var big = picked.length >= HI;

      plans.forEach(function (p) {
        var isBig = parseInt(p.dataset.size, 10) === HI;
        p.setAttribute('aria-pressed', isBig === big ? 'true' : 'false');
      });

      cards.forEach(function (c) {
        c.el.setAttribute('aria-pressed', picked.indexOf(c.it.id) === -1 ? 'false' : 'true');
      });

      if (hintEl) { hintEl.textContent = big ? (copy.hint_full || '') : (copy.hint_part || ''); }
      if (namesEl) { namesEl.textContent = picked.length ? picked.map(nameOf).join(', ') : (copy.none || ''); }
      if (wasEl) { wasEl.textContent = big ? (copy.was_large || '') : (copy.was_small || ''); }
      if (nowEl) { nowEl.textContent = big ? (copy.price_large || '') : (copy.price_small || ''); }

      var buyable = items.filter(function (it) { return it.ok; }).length;
      if (buyable < LO) {
        cta.disabled = true;
        cta.textContent = copy.sold_out || '';
      } else {
        cta.disabled = false;
        cta.textContent = (copy.add || '') + ' ' + (big ? (copy.price_large || '') : (copy.price_small || ''));
      }
    }

    cta.addEventListener('click', function () {
      if (cta.disabled || !picked.length) { return; }
      cta.disabled = true;
      cta.textContent = copy.adding || cta.textContent;

      /* Locale-aware root, so the request stays in the visitor's market and language. */
      var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: picked.map(function (id) { return { id: id, quantity: 1 }; })
        })
      })
        .catch(function () { return null; })
        .then(function (r) {
          if (r && r.ok) { window.location.href = cartRoot + 'cart'; return; }
          /* Something sold out while the page was open: say so and let them try again,
             rather than leaving a dead button. */
          cta.disabled = false;
          render();
          if (say) { say.textContent = copy.sold_out || ''; }
        });
    });

    render();
  }

  function boot() {
    var banner = document.getElementById('aurbb');
    if (banner && !banner.dataset.ready) {
      banner.dataset.ready = '1';
      startClock(banner, readJSON(banner, '[data-aurbb-copy]') || {});
    }
    var picker = document.getElementById('aurfb');
    if (picker && !picker.dataset.ready) {
      picker.dataset.ready = '1';
      startPicker(picker);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* The theme editor re-renders a section without reloading the page. */
  document.addEventListener('shopify:section:load', boot);
})();
